import ContentClient from '../common/ContentClient';

export class OLContentClient extends ContentClient {
    // for future integration with secure content
    static ASSESSMENT_SHORT_NAME = 'ol';

    static BASE_URL = '/ol-api/content/v1';

    static FORMS_URL = `${OLContentClient.BASE_URL}/forms`;

    static CUTSCORES_URL = `${OLContentClient.BASE_URL}/cutscores`;
}

export default OLContentClient;
